module.exports = __webpack_public_path__ + "img/LOGO_color.3d090387.svg";